import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const RealtimeActivity = () => {
  const [activities, setActivities] = useState([]);

  const mockActivities = [
    {
      id: 1,
      type: 'email_open',
      title: 'Email Opened',
      description: 'Press release "New Fantasy Novel Launch" opened by Sarah Johnson',
      timestamp: new Date(Date.now() - 300000),
      icon: 'Mail',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      id: 2,
      type: 'press_kit_download',
      title: 'Press Kit Downloaded',
      description: 'Complete press kit downloaded by TechCrunch editor',
      timestamp: new Date(Date.now() - 600000),
      icon: 'Download',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      id: 3,
      type: 'media_mention',
      title: 'Media Mention Detected',
      description: 'PenGame Publishing mentioned in BookWorld Magazine',
      timestamp: new Date(Date.now() - 900000),
      icon: 'MessageSquare',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      id: 4,
      type: 'contact_interaction',
      title: 'Contact Engagement',
      description: 'Michael Chen clicked press release link',
      timestamp: new Date(Date.now() - 1200000),
      icon: 'Users',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    },
    {
      id: 5,
      type: 'email_click',
      title: 'Link Clicked',
      description: 'Author bio link clicked in campaign email',
      timestamp: new Date(Date.now() - 1500000),
      icon: 'ExternalLink',
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-50'
    }
  ];

  useEffect(() => {
    setActivities(mockActivities);
    
    // Simulate real-time updates
    const interval = setInterval(() => {
      const newActivity = {
        id: Date.now(),
        type: 'email_open',
        title: 'New Activity',
        description: 'Real-time activity simulation',
        timestamp: new Date(),
        icon: 'Activity',
        color: 'text-success',
        bgColor: 'bg-success/10'
      };
      
      setActivities(prev => [newActivity, ...prev?.slice(0, 4)]);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-success/10 rounded-lg">
              <Icon name="Activity" size={20} className="text-success" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">Real-time Activity</h3>
              <p className="text-sm text-muted-foreground">Live engagement monitoring</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm text-success font-medium">Live</span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start space-x-4 p-3 rounded-lg hover:bg-muted/50 transition-colors duration-200">
              <div className={`p-2 rounded-lg ${activity?.bgColor}`}>
                <Icon name={activity?.icon} size={16} className={activity?.color} />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h4 className="text-sm font-medium text-foreground">{activity?.title}</h4>
                  <span className="text-xs text-muted-foreground">{formatTimestamp(activity?.timestamp)}</span>
                </div>
                <p className="text-sm text-muted-foreground mt-1">{activity?.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-4 pt-4 border-t border-border">
          <button className="w-full text-sm text-primary hover:text-primary/80 font-medium transition-colors duration-200">
            View All Activity
          </button>
        </div>
      </div>
    </div>
  );
};

export default RealtimeActivity;